<script>
import Endpoints from '../../../components/common/Endpoints';
import Request from '../../../components/common/Request';

export default {
    init: async(payload) => {
        payload.domain = Endpoints.domain;
    },
    methods:{
        filter: function(){
            let state = this;
            state.truckers = [];
            setTimeout(async function(){
              let trucker = (await Request.do(state, 'POST', Request.getDefaultHeader(state),state.filters,`${Endpoints.systemUsers.filter}`));
                if (trucker.status==200){
                    state.truckers = trucker.data.results;
                }
        }, 100);
        },
    }
 
}
</script>
